import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box'
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { useApi } from "lib/api";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TwoWheelerOutlinedIcon from '@mui/icons-material/TwoWheelerOutlined';
import { Divider, Chip } from '@mui/material';
import profileimage from 'assets/images/profileimage.webp'

function Detalleexpediente(props) {
  const {id,data} = useParams();
  const { post } = useApi();
  const [rows, setRows] = useState([])
  const [balanceatraso, setBalanceatraso] = useState([])
  const [cuotavencida, setCuotavencida] = useState([])
  const [chasisList, setChasisList] = useState([])

  const [expanded, setExpanded] = useState(0);
  const [currentItem,setCurrentItem] = useState()
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    post('/api/recuperarexpediente', { cedula: data, id: id }).then(({ status, data: resp }) => {
      if (status === 200) {
        setRows(resp["balanceactual"])
        setBalanceatraso(resp["balanceatraso"])
        setChasisList(resp["chasis"] || [])
      }
      if (status === 400) {
        setRows([])
        alert(resp["Error"])
      }
    })
  },[]);

  function getAtraso(noprest){
    const value = balanceatraso.filter(value=>value.id==noprest)
    if(value.length!=0){
        return value[0]
    }else{
        return {proyectado:0,cantcuotas:0}
    }

  }

  function getChasisDelPrestamo(noprest){
    return (chasisList || []).filter(c => String(c.noprest) === String(noprest));
  }

    return(
        <Box
          sx={{
            px: { xs: 1.5, sm: 3, md: 5 },
            py: { xs: 2, sm: 3 },
            maxWidth: 900,
            mx: 'auto',
            boxSizing: 'border-box',
          }}
        >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'center', sm: 'center' },
                flexWrap: 'wrap',
                gap: { xs: 1.5, sm: 3 },
                mt: { xs: 7, sm: 4 },
                mb: 1,
                p: { xs: 2, sm: 2.5 },
                borderRadius: 2.5,
                backgroundColor: 'white',
                boxShadow: '0 1px 2px rgba(15,23,42,0.04), 0 8px 22px rgba(15,23,42,0.06)',
              }}
            >
              <Box
                component="img"
                src={profileimage}
                alt="perfil"
                sx={{
                  backgroundColor: 'grey.300',
                  width: { xs: 96, sm: 120, md: 130 },
                  height: { xs: 96, sm: 120, md: 130 },
                  borderRadius: '50%',
                  objectFit: 'cover',
                  flexShrink: 0,
                }}
              />
              <Box
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  minWidth: 0,
                  flex: 1,
                }}
              >
                <Typography
                  fontWeight="bold"
                  sx={{
                    fontSize: { xs: '1.1rem', sm: '1.5rem' },
                    wordBreak: 'break-word',
                  }}
                >
                  {rows.length!=0?rows[0]["nombres"]:''}
                </Typography>
                <Typography
                  fontWeight="bold"
                  sx={{
                    fontSize: { xs: '0.95rem', sm: '1.25rem' },
                    color: 'text.secondary',
                    wordBreak: 'break-word',
                  }}
                >
                  {rows.length!=0?rows[0]["cedula"]:''}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ mt: { xs: 2, sm: 4 } }}>
                {rows.map((value,i)=>(
                    <Accordion
                      key={value["id"] ?? i}
                      expanded={expanded === i}
                      onChange={handleChange(i)}
                      sx={{
                        mb: 1,
                        borderRadius: 2,
                        '&:before': { display: 'none' },
                      }}
                    >
                        <AccordionSummary
                            onClick={()=>{setCurrentItem(value)}}
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel-content-${i}`}
                            id={`panel-header-${i}`}
                            sx={{
                              fontWeight: 'bold',
                              fontSize: { xs: '0.95rem', sm: '1rem' },
                            }}
                        >
                            {`Préstamo #${value["id"]}`}
                        </AccordionSummary>
                        <Box>
                          <Grid container sx={{ p: { xs: 2, sm: 3 } }} spacing={1}>
                              <Grid item xs={12}>
                                  <Typography
                                    sx={{
                                      fontSize: { xs: '0.875rem', sm: '0.95rem' },
                                      wordBreak: 'break-word',
                                      mb: 0.5,
                                    }}
                                  >
                                    <strong style={{color:"#5e5757"}}>Balance pendiente total:</strong> {value.balanceactual}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: { xs: '0.875rem', sm: '0.95rem' },
                                      wordBreak: 'break-word',
                                      mb: 0.5,
                                    }}
                                  >
                                    <strong style={{color:"#5e5757"}}>Balance en atraso:</strong> {getAtraso(value["id"]).proyectado}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: { xs: '0.875rem', sm: '0.95rem' },
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    <strong style={{color:"#5e5757"}}>Cuotas vencidas:</strong> {getAtraso(value["id"]).cantcuotas} {getAtraso(value["id"]).tipodepago}
                                  </Typography>

                                  {getChasisDelPrestamo(value["id"]).length > 0 ? (
                                    <Box sx={{ mt: 2 }}>
                                      <Divider sx={{ mb: 1.5 }} />
                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <TwoWheelerOutlinedIcon sx={{ fontSize: 20, color: '#111827', mr: 0.5 }} />
                                        <Typography sx={{ fontWeight: 'bold', color: '#111827', fontSize: '0.9rem' }}>
                                          Datos del chasis
                                          {getChasisDelPrestamo(value["id"]).length > 1 ? ` (${getChasisDelPrestamo(value["id"]).length})` : ''}
                                        </Typography>
                                      </Box>
                                      {getChasisDelPrestamo(value["id"]).map((ch, idx, arr) => (
                                        <Box key={idx} sx={{ mb: idx < arr.length - 1 ? 1.5 : 0, pt: idx > 0 ? 1.5 : 0, borderTop: idx > 0 ? '1px solid #f1f5f9' : 'none' }}>
                                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 0.5 }}>
                                            {ch.marca ? <Chip size="small" label={ch.marca} sx={{ backgroundColor: '#dbeafe', color: '#2563eb', fontWeight: 700 }} /> : null}
                                            {ch.condicion ? <Chip size="small" label={ch.condicion} sx={{ backgroundColor: '#f1f5f9', color: '#64748b', fontWeight: 600 }} /> : null}
                                          </Box>
                                          <Typography sx={{ fontSize: '0.85rem', wordBreak: 'break-word' }}>
                                            <strong style={{ color: '#5e5757' }}>Chasis:</strong> {ch.chasis || '—'}
                                          </Typography>
                                          <Typography sx={{ fontSize: '0.85rem' }}>
                                            <strong style={{ color: '#5e5757' }}>Modelo:</strong> {ch.modelo || '—'}
                                          </Typography>
                                          <Typography sx={{ fontSize: '0.85rem' }}>
                                            <strong style={{ color: '#5e5757' }}>Color:</strong> {ch.color || '—'}
                                          </Typography>
                                          <Typography sx={{ fontSize: '0.85rem' }}>
                                            <strong style={{ color: '#5e5757' }}>Costo:</strong> ${ch.costo || '—'}
                                          </Typography>
                                          <Typography sx={{ fontSize: '0.85rem', color: '#10b981' }}>
                                            <strong style={{ color: '#5e5757' }}>Precio:</strong> ${ch.precio || '—'}
                                          </Typography>
                                          {ch.placa ? <Typography sx={{ fontSize: '0.85rem' }}><strong style={{ color: '#5e5757' }}>Placa:</strong> {ch.placa}</Typography> : null}
                                          {ch.endoso ? <Typography sx={{ fontSize: '0.85rem' }}><strong style={{ color: '#5e5757' }}>Endoso:</strong> {ch.endoso}</Typography> : null}
                                        </Box>
                                      ))}
                                    </Box>
                                  ) : null}
                              </Grid>
                          </Grid>
                        </Box>
                    </Accordion>
                ))}
            </Box>
        </Box>
    );
}
export default Detalleexpediente
